import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import { getTeacherSubjects } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { ClipboardList, BookOpen, ArrowRight } from 'lucide-react';

export default function TeacherGradesList() {
  const navigate = useNavigate();
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const data = await getTeacherSubjects();
        setSubjects(data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    fetch();
  }, []);

  if (loading) return <Layout><div className="p-6 flex items-center justify-center min-h-[60vh]"><div className="spinner" /></div></Layout>;

  return (
    <Layout>
      <div className="p-6 md:p-8" data-testid="teacher-grades-list">
        <h1 className="font-heading text-2xl sm:text-3xl tracking-tight font-medium text-[#1A1A1A] mb-2">
          Notas y Asistencia
        </h1>
        <p className="text-[#737373] mb-6">Selecciona un curso para gestionar notas y asistencia</p>

        {subjects.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {subjects.map(sub => (
              <Card key={sub.id} className="bg-white border border-[#E5DFD3] shadow-sm hover:shadow-md transition-shadow cursor-pointer" onClick={() => navigate(`/teacher/grades/${sub.id}?title=${encodeURIComponent(sub.title)}`)}>
                <CardContent className="pt-6">
                  <div className="flex items-start gap-4">
                    <div className="h-12 w-12 rounded-lg bg-[#8B1538]/10 flex items-center justify-center shrink-0">
                      <ClipboardList className="h-6 w-6 text-[#8B1538]" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-heading text-base font-medium text-[#1A1A1A] truncate">{sub.title}</h3>
                      <p className="text-xs text-[#737373] mt-0.5">{sub.module_title}</p>
                      <p className="text-xs text-[#B8860B] mt-1">{sub.classes_count} clases</p>
                    </div>
                    <ArrowRight className="h-5 w-5 text-[#D9B48F] shrink-0 mt-1" />
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <BookOpen className="h-12 w-12 mx-auto text-[#D9B48F] mb-3" />
            <p className="text-[#737373]">No tienes cursos asignados</p>
          </div>
        )}
      </div>
    </Layout>
  );
}
